import React from "react";
import { motion } from "framer-motion";

const brandLogos = [
  { name: "Matsuyama", logo: "/matsuyama.png" },
  { name: "XRF", logo: "/xrf.svg" },
  { name: "Thermo", logo: "/thermo.png" },
  { name: "Sartorius", logo: "/sartorius.png" },
  { name: "Schneider", logo: "/su.svg" },
  { name: "Anton", logo: "/anton.png" },
  { name: "FLS", logo: "/fls.svg" },
  { name: "Essa", logo: "/essa.jpg" },
  { name: "Merck", logo: "/merck.svg" },
  { name: "Ohaus", logo: "/ohaus.png" },
  { name: "Hach", logo: "/hach.png" },
  { name: "Memmert", logo: "/memmert.png" },
  { name: "Retsch", logo: "/retch.png" },
];

export const LogoMarque = () => {
  return (
    <motion.div
      className="bg-[#fff] text-black text-sm overflow-hidden whitespace-nowrap rounded-lg shadow-md mb-6"
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6 }}
    >
      <div className="animate-marquee py-2 flex items-center gap-8">
        {brandLogos.map((brand) => (
          <motion.img
            key={brand.name}
            src={brand.logo}
            alt={brand.name}
            className="h-10 md:h-14 object-contain grayscale hover:grayscale-0 transition duration-300 drop-shadow-[0_1px_2px_rgba(0,0,0,0.3)]"
            whileHover={{ scale: 1.1 }}
          />
        ))}
      </div>
    </motion.div>
  );
};
